import React from 'react';

const SuccessFeedbackIcon: React.FC = () => {
  return (
    <svg width="289" height="140" viewBox="0 0 289 140" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.5"
        d="M4.21512 61.2595C6.46446 61.2595 8.2879 59.436 8.2879 57.1867C8.2879 54.9373 6.46446 53.1139 4.21512 53.1139C1.96578 53.1139 0.142334 54.9373 0.142334 57.1867C0.142334 59.436 1.96578 61.2595 4.21512 61.2595Z"
        fill="#0090FF"
      />
      <path
        d="M75.2626 35.9177C76.7621 35.9177 77.9778 34.7021 77.9778 33.2025C77.9778 31.7029 76.7621 30.4873 75.2626 30.4873C73.763 30.4873 72.5474 31.7029 72.5474 33.2025C72.5474 34.7021 73.763 35.9177 75.2626 35.9177Z"
        fill="#0090FF"
      />
      <rect x="100" y="16" width="90" height="90" rx="36" fill="#0090FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M163.134 51.3847C164.305 52.5563 164.305 54.4558 163.134 55.6274L142.627 76.1335C141.456 77.305 139.556 77.305 138.385 76.1335L125.879 63.6274C124.707 62.4558 124.707 60.5563 125.879 59.3847C127.05 58.2132 128.95 58.2132 130.121 59.3847L140.506 69.7695L158.891 51.3847C160.062 50.2132 161.962 50.2132 163.134 51.3847Z"
        fill="white"
      />
      <path
        d="M284.332 111.038C286.831 111.038 288.857 109.012 288.857 106.513C288.857 104.013 286.831 101.987 284.332 101.987C281.833 101.987 279.807 104.013 279.807 106.513C279.807 109.012 281.833 111.038 284.332 111.038Z"
        fill="#0090FF"
      />
    </svg>
  );
};

export default SuccessFeedbackIcon;
